import { Divider, Grid, IconButton, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import {
  Control,
  FieldErrors,
  UseFormRegister,
  UseFormReset,
  UseFormSetValue,
} from "react-hook-form";

import { WSIcons } from "../../commonFunctions/iIcons";
import WSFilterButtonGroup from "../Filter/WSFilterButtonGroup";

interface PrescriptionProps {
  control?: Control<any>;
  errors?: FieldErrors;
  register: UseFormRegister<any>;
  id: any;
  reset: UseFormReset<any>;
  noteId?: string;
  setValue: UseFormSetValue<any>;
  onCancel: () => void;
}

const NotificationDrawer: React.FC<PrescriptionProps> = ({
  control,
  id,
  register,
  noteId,
  reset,
  setValue,
  onCancel,
}) => {
  useEffect(() => {
    return () => {
      reset();
    };
  }, []);
  const filters = ["All", "Payments", "Return"];
  const [selectedFilter, setSelectedFilter] = useState(filters[0]);

  const notifications = [
    {
      icon: <WSIcons.BsBox2Fill style={{ color: "#CEEEE5", fontSize: 20 }} />,
      text: "New order #ORD1085 received from Nitin Menon.",
      time: " 10 Oct, 2026 | 09:06 AM",
    },
    {
      icon: <WSIcons.BsBox2Fill style={{ color: "#CEEEE5", fontSize: 20 }} />,
      text: "Order #ORD1075 marked as Delivered by delivery agent.",
      time: " 10 Oct, 2026 | 09:06 AM",
    },
    {
      icon: (
        <WSIcons.GiTakeMyMoney style={{ color: "#CEEEE5", fontSize: 20 }} />
      ),
      text: "₹850 payment successfully received for Order #ORD1075 from Ragu Raghavan.",
      time: " 10 Oct, 2026 | 09:06 AM",
    },
    {
      icon: <WSIcons.BsBox2Fill style={{ color: "#CEEEE5", fontSize: 20 }} />,
      text: "Order #ORD1078 was cancelled due to wrong medicine.",
      time: " 10 Oct, 2026 | 09:06 AM",
    },
    {
      icon: (
        <WSIcons.TbTruckReturn style={{ color: "#F21E1E", fontSize: 20 }} />
      ),
      text: "Return request received for Order #ORD1060.",
      time: " 10 Oct, 2026 | 09:06 AM",
    },
    {
      icon: (
        <WSIcons.BsFileTextFill style={{ color: "#CEEEE5", fontSize: 20 }} />
      ),
      text: "New order #ORD1085 received, prescription from Lakshya Menon.",
      time: " 10 Oct, 2026 | 09:06 AM",
    },
    {
      icon: (
        <WSIcons.BsFileTextFill style={{ color: "#CEEEE5", fontSize: 20 }} />
      ),
      text: "New order #ORD1091 received, prescription from Lakshya Menon.",
      time: " 10 Oct, 2026 | 09:06 AM",
    },
       {
      icon: (
        <WSIcons.BsFileTextFill style={{ color: "#CEEEE5", fontSize: 20 }} />
      ),
      text: "New order #ORD1091 received, prescription from Lakshya Menon.",
      time: " 10 Oct, 2026 | 09:06 AM",
    },
       {
      icon: (
        <WSIcons.BsFileTextFill style={{ color: "#CEEEE5", fontSize: 20 }} />
      ),
      text: "New order #ORD1091 received, prescription from Lakshya Menon.",
      time: " 10 Oct, 2026 | 09:06 AM",
    },
  ];

  return (
    <>
    <Grid container spacing={2} mt={2}>
      <Grid item xs={12}>
        <WSFilterButtonGroup
          options={filters}
          selected={selectedFilter}
          onChange={(value) => setSelectedFilter(value)}
        />
      </Grid>

      <Grid item xs={12}>
        <Typography>Today</Typography>
      </Grid>
</Grid>
      {notifications.map((item, index) => (
        <Grid container key={index} spacing={2} mt={1}>
          <Grid item xs={12} sm={2}>
            <IconButton
              sx={{
                width: 30,
                height: 30,
                borderRadius: "8px",
                border: "1px solid #828584",
                p: 0,
              }}
            >
              {item.icon}
            </IconButton>
          </Grid>

          <Grid item xs={12} sm={10}>
            <Typography  >
              {item.text}{" "}
            </Typography>

            <Typography variant="caption" color={"GrayText"}>
              {item.time}{" "}
            </Typography>
          </Grid>
        

          <Grid item xs={12} mt={1}>
            <Divider />
          </Grid>
        </Grid>
      ))}
      </>
  );
};
export default NotificationDrawer;
